import {
  fixFeatureButton,
  customizeSearch,
  createCustomToggle,
  updateContentMargin,
} from '../js/helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  customizeSearch();
  createCustomToggle();
  modifySignup();
  createMapButton();
  updateContentMargin();
});

// ****************************************************************************************************************************************************
// Customizes the signup widget on the homepage

function modifySignup() {
  const signupWidget = $('.homepage .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h2>Join our email Newsletter!</h2>
        <p>Stay up to date with everything happening at the Northwestern Michigan Fair and never miss an event!</p>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Enter Email')
      .attr('aria-label', 'Enter Email Address');

    submitButton.find('.emailSubmitButton').text('Sign Up Now!');
  });
}

// ****************************************************************************************************************************************************
// Adds the Directions button to the homepage map

function createMapButton() {
  const mapHref = $('.standAloneDirections');
  mapHref.addClass('button');
  mapHref.text('Directions');

  $('.address-box').append(mapHref);
}
